'use strict';

import { Matrix3, MeshStandardMaterial } from 'three';

const layer_vertex_vars = `
varying vec2 vMaskUv;
uniform mat3 uMaskTransform;
`;

const layer_vertex_main = `
vMaskUv = ( uMaskTransform * vec3( MASK_UV, 1 ) ).xy;
`;

const layer_fragment_vars = `
varying vec2 vMaskUv;
uniform sampler2D uMask;
`;

const layer_fragment_main = `
 vec4 mask = texture2D(uMask,vMaskUv);
 gl_FragColor.a = mask.r;
`;


export class LayerMaterial extends MeshStandardMaterial{
	constructor (parameters) {
		super(parameters);
	
		this.transparent = true;
		this.defines.LAYER_MATERIAL = '';
		this.defines.MASK_UV = 'uv';
		this.defines.USE_UV1 = '';
		this.mask = parameters?.mask ? parameters.mask : null;
		this.customPrograms = [this.upgradeShader.bind(this)];
	}
	
	upgradeShader(shader) {
		if (this.mask) {
			this.mask.updateMatrix();
		}
		
		shader.uniforms.uMask = {value:this.mask};
		shader.uniforms.uMaskTransform = {value: this.mask ? this.mask.matrix.clone() : new Matrix3()};
		shader.defines.MASK_UV = this.mask ? this.#getActiveChannel(this.mask.channel) : this.#getActiveChannel(0);
		
		shader.vertexShader = layer_vertex_vars + shader.vertexShader;
		shader.vertexShader = shader.vertexShader.replace('#include <uv_vertex>',[
			layer_vertex_main,
			'#include <uv_vertex>'
		].join('\n'));
		
		shader.fragmentShader = layer_fragment_vars + shader.fragmentShader;
		shader.fragmentShader = shader.fragmentShader.replace('#include <opaque_fragment>',[
			'#include <opaque_fragment>',
			layer_fragment_main
		].join('\n'));
	}
	
	#getActiveChannel(value) {
		if ( value === 0 ) return 'uv';
		
		return `uv${ value }`;
	}
	
}
